(function () {
  'use strict';

  const STORAGE_KEY = 'pf_comparator_products';

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatPrice(cents) {
    if (cents === 0 || cents == null) return '';
    return (cents / 100).toLocaleString('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0,
    });
  }

  class ProductComparator {
    constructor() {
      const configEl = document.getElementById('comparator-config');
      if (!configEl) return;

      this.config       = JSON.parse(configEl.textContent);
      this.products     = this._restore();
      this.bar          = document.getElementById('comparator-bar');
      this.barSlots     = document.getElementById('comparator-bar-slots');
      this.barCta       = document.getElementById('comparator-bar-cta');
      this.barClear     = document.getElementById('comparator-bar-clear');
      this.modal        = document.getElementById('comparator-modal');
      this.modalContent = document.getElementById('comparator-modal-content');

      if (!this.bar || !this.modal) return;

      this._bindStaticEvents();
      this._renderBar();
      this._syncCardButtons();
    }

    toggle(productData) {
      const idx = this.products.findIndex(p => p.id === productData.id);
      if (idx !== -1) {
        this.products.splice(idx, 1);
      } else {
        if (this.products.length >= this.config.max_products) return;
        this.products.push(productData);
      }
      this._persist();
      this._renderBar();
      this._syncCardButtons();
    }

    isSelected(id) {
      return this.products.some(p => p.id === id);
    }

    openModal() {
      this._buildTable();
      this.modal.showModal();
      document.body.classList.add('comparator-open');
      document.getElementById('comparator-modal-close').focus();
    }

    closeModal() {
      this.modal.close();
      document.body.classList.remove('comparator-open');
    }

    clear() {
      this.products = [];
      this._persist();
      this._renderBar();
      this._syncCardButtons();
    }

    _bindStaticEvents() {
      this.barCta.addEventListener('click', () => this.openModal());
      this.barClear.addEventListener('click', () => this.clear());

      document.getElementById('comparator-modal-close')
        .addEventListener('click', () => this.closeModal());

      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.closeModal();
      });

      this.modal.addEventListener('close', () => {
        document.body.classList.remove('comparator-open');
      });

      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-comparator-btn]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        try {
          this.toggle(JSON.parse(btn.dataset.product));
        } catch (_) {}
      });

      document.addEventListener('comparator:sync', () => this._syncCardButtons());

      // Sync buttons added dynamically (infinite scroll, load-more, AJAX pagination)
      // Observe only the product grid area, never the comparator bar itself
      const observeTarget = document.getElementById('ProductGridContainer') ||
                            document.querySelector('.product-grid') ||
                            document.querySelector('main');
      if (observeTarget) {
        const observer = new MutationObserver((mutations) => {
          for (const m of mutations) {
            for (const node of m.addedNodes) {
              if (node.nodeType !== 1) continue;
              if (node.matches('[data-comparator-btn]') || node.querySelector('[data-comparator-btn]')) {
                this._syncCardButtons();
                return;
              }
            }
          }
        });
        observer.observe(observeTarget, { childList: true, subtree: true });
      }

      this.modal.addEventListener('click', (e) => {
        const varBtn = e.target.closest('.cmp-sizes .variant-button');
        if (!varBtn) return;
        const pid = varBtn.dataset.cmpPid;
        this.modal.querySelectorAll(`.variant-button[data-cmp-pid="${pid}"]`).forEach(b => b.classList.remove('selected'));
        varBtn.classList.add('selected');
        const atcBtn = this.modal.querySelector(`.cmp-atc[data-cmp-pid="${pid}"]`);
        if (atcBtn) {
          atcBtn.style.width = '';
          atcBtn.style.minWidth = '';
          atcBtn.disabled = false;
          atcBtn.dataset.variantId = varBtn.dataset.variantId;
          atcBtn.querySelector('span').textContent = this.config.labels.add_to_cart;
        }
      });

      this.modal.addEventListener('click', (e) => {
        const atcBtn = e.target.closest('.cmp-atc');
        if (!atcBtn || atcBtn.disabled) return;
        const variantId = atcBtn.dataset.variantId;
        if (!variantId) return;
        const lockedWidth = atcBtn.offsetWidth + 'px';
        atcBtn.style.width = lockedWidth;
        atcBtn.style.minWidth = lockedWidth;
        atcBtn.disabled = true;
        atcBtn.querySelector('span').textContent = this.config.labels.adding;
        setTimeout(() => {
          this.closeModal();
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, sections: ['cart-drawer'] }),
          })
            .then(r => r.json())
            .then((data) => {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && data.sections && data.sections['cart-drawer']) {
                const parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
                const newInner = parsed.querySelector('.drawer__inner');
                const currentInner = cartDrawer.querySelector('.drawer__inner');
                if (newInner && currentInner) {
                  currentInner.className = newInner.className;
                  currentInner.innerHTML = newInner.innerHTML;
                }
                cartDrawer.classList.toggle('is-empty', !newInner || newInner.classList.contains('is-empty'));
                cartDrawer.open();
              } else {
                if (typeof updateCartDrawer === 'function') updateCartDrawer(true);
              }
              if (typeof updateCartIconBubble === 'function') updateCartIconBubble();
            })
            .catch(() => {});
        }, 350);
      });
    }

    _renderBar() {
      const count  = this.products.length;
      const max    = this.config.max_products;
      const labels = this.config.labels;

      this.bar.classList.toggle('is-visible', count > 0);
      this.bar.setAttribute('aria-hidden', String(count === 0));
      this.barCta.disabled = count < 2;

      let html = '';
      for (let i = 0; i < max; i++) {
        const p = this.products[i];
        if (p) {
          html += `
            <div class="comparator-bar__slot comparator-bar__slot--filled">
              <div class="comparator-bar__slot-img-wrap">
                <img src="${escHtml(p.image)}" alt="${escHtml(p.title)}" width="56" height="56" loading="lazy">
              </div>
              <button type="button" class="comparator-bar__slot-remove" aria-label="${escHtml(labels.remove)} ${escHtml(p.title)}" data-remove-id="${p.id}">&#x2715;</button>
            </div>`;
        } else {
          html += `<div class="comparator-bar__slot comparator-bar__slot--empty"><span aria-hidden="true">+</span></div>`;
        }
      }

      this.barSlots.innerHTML = html;

      this.barSlots.querySelectorAll('[data-remove-id]').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = parseInt(btn.dataset.removeId, 10);
          this.products = this.products.filter(p => p.id !== id);
          this._persist();
          this._renderBar();
          this._syncCardButtons();
        });
      });
    }

    _buildTable() {
      const { products, config } = this;
      const { fields, labels }   = config;

      let html = '<div class="comparator-table-wrap"><table class="comparator-table">';

      html += '<thead><tr><th class="comparator-table__th-label" scope="col"></th>';
      products.forEach((p, colIdx) => {
        html += `
          <th class="comparator-table__th-product" data-col-index="${colIdx}" scope="col">
            <div class="comparator-table__product">
              <button type="button" class="comparator-table__remove" aria-label="${escHtml(labels.remove)} ${escHtml(p.title)}" data-remove-id="${p.id}">&#x2715;</button>
              <a href="${escHtml(p.url)}" class="comparator-table__img-link">
                <img src="${escHtml(p.image)}" alt="${escHtml(p.title)}" width="200" height="240" loading="lazy">
              </a>
              <p class="comparator-table__name">${escHtml(p.title)}</p>
              <a href="${escHtml(p.url)}" class="comparator-table__cta button button--secondary">${escHtml(labels.view_product)}</a>
            </div>
          </th>`;
      });
      html += '</tr></thead>';

      html += '<tbody>';
      fields.forEach(field => {
        html += `<tr><td class="comparator-table__label">${escHtml(field.label)}</td>`;
        products.forEach((p, colIdx) => {
          const value = p.fields ? p.fields[field.key] : undefined;
          html += `<td class="comparator-table__value" data-col-index="${colIdx}">${this._renderField(field, value, p)}</td>`;
        });
        html += '</tr>';
      });
      html += '</tbody></table></div>';

      this.modalContent.innerHTML = html;

      const table = this.modalContent.querySelector('.comparator-table');
      if (table) table.style.setProperty('--cmp-product-count', products.length);

      this._initMobileNav();
      this._applyValuePadding();
      this._initScrollFade();

      this.modalContent.querySelectorAll('[data-remove-id]').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = parseInt(btn.dataset.removeId, 10);
          this.products = this.products.filter(p => p.id !== id);
          this._persist();
          this._renderBar();
          this._syncCardButtons();
          if (this.products.length === 0) {
            this.closeModal();
          } else {
            this._buildTable();
          }
        });
      });
    }

    _getMobilePairs() {
      const n = this.products.length;
      if (n <= 2) return null;
      return Array.from({ length: n }, (_, i) => [i, (i + 1) % n]);
    }

    _initMobileNav() {
      this._mobilePairs   = null;
      this._mobilePairIdx = 0;

      const pairs = this._getMobilePairs();
      if (!pairs) return;

      this._mobilePairs = pairs;

      const theadRow = this.modalContent.querySelector('.comparator-table thead tr');
      theadRow.insertAdjacentHTML('afterbegin',
        `<th class="cmp-nav-th" aria-hidden="true">` +
          `<button type="button" class="cmp-nav-btn" id="cmp-nav-prev" aria-label="Par anterior">&#8249;</button>` +
        `</th>`
      );
      theadRow.insertAdjacentHTML('beforeend',
        `<th class="cmp-nav-th" aria-hidden="true">` +
          `<button type="button" class="cmp-nav-btn" id="cmp-nav-next" aria-label="Par siguiente">&#8250;</button>` +
        `</th>`
      );

      const dotsHtml =
        `<tr class="cmp-dots-row"><td colspan="99">` +
          `<div class="cmp-mobile-dots">` +
            pairs.map((_, i) =>
              `<span class="cmp-mobile-nav__dot${i === 0 ? ' is-active' : ''}"></span>`
            ).join('') +
          `</div>` +
        `</td></tr>`;
      this.modalContent.querySelector('.comparator-table tbody')
        .insertAdjacentHTML('afterbegin', dotsHtml);

      document.getElementById('cmp-nav-prev').addEventListener('click', () => {
        this._mobilePairIdx = (this._mobilePairIdx - 1 + pairs.length) % pairs.length;
        this._applyMobileView();
      });
      document.getElementById('cmp-nav-next').addEventListener('click', () => {
        this._mobilePairIdx = (this._mobilePairIdx + 1) % pairs.length;
        this._applyMobileView();
      });

      this._applyMobileView();
    }

    _applyMobileView() {
      if (!this._mobilePairs) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const pair     = this._mobilePairs[this._mobilePairIdx];

      const table = this.modalContent.querySelector('.comparator-table');
      if (table) table.style.setProperty('--cmp-product-count', isMobile ? 2 : this.products.length);

      this.modalContent.querySelectorAll('[data-col-index]').forEach(el => {
        const idx      = parseInt(el.dataset.colIndex, 10);
        const pairPos  = pair.indexOf(idx);
        const visible  = !isMobile || pairPos !== -1;
        el.style.display = visible ? '' : 'none';
        el.style.order   = (isMobile && visible) ? String(pairPos + 1) : '';
        if (isMobile && visible && el.classList.contains('comparator-table__value')) {
          el.style.paddingLeft  = pairPos === 1 ? '10px' : '';
          el.style.paddingRight = pairPos === 0 ? '10px' : '';
        }
        if (isMobile && visible && el.classList.contains('comparator-table__th-product')) {
          el.style.paddingRight = pairPos === 0 ? '20px' : '';
          el.style.paddingLeft  = pairPos === 1 ? '20px' : '';
        }
      });

      this.modalContent.querySelectorAll('.cmp-mobile-nav__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this._mobilePairIdx);
      });
    }

    _renderField(field, value, product) {
      if (field.type === 'price') return this._renderPrice(product);
      if (field.type === 'rating') return this._renderRating(product);

      if (value === null || value === undefined || value === '' || value === 'null') {
        return '<span class="comparator-table__empty">—</span>';
      }

      switch (field.type) {
        case 'sizes': {
          if (!Array.isArray(value) || value.length === 0) {
            return '<span class="comparator-table__empty">—</span>';
          }
          const hasVariantIds = typeof value[0] === 'object' && value[0] !== null && 'id' in value[0];
          if (!hasVariantIds) {
            return value.map(s => `<span class="comparator-table__size-chip">${escHtml(String(s))}</span>`).join('');
          }
          const pid = product.id;
          const sizeButtons = value.map(s =>
            `<button type="button" class="variant-button" data-variant-id="${s.id}" data-cmp-pid="${pid}">${escHtml(String(s.label))}</button>`
          ).join('');
          return `<div class="cmp-sizes">` +
            `<div class="cmp-sizes__scroll-wrap"><div class="variant-buttons">${sizeButtons}</div></div>` +
            `<button type="button" class="product-form__submit button card-product-submit cmp-atc" disabled data-cmp-pid="${pid}">` +
              `<span>${escHtml(this.config.labels.add_to_cart)}</span>` +
            `</button>` +
            `</div>`;
        }

        case 'composition':
          return this._renderComposition(String(value));

        case 'html':
          return value || '<span class="comparator-table__empty">—</span>';

        case 'text':
        default:
          return `<span>${escHtml(String(value))}</span>`;
      }
    }

    _renderComposition(value) {
      const byLine = value.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
      const flat   = byLine.join(' ').trim();
      const clean  = s => s.trim().replace(/^[–\-]\s*/, '').replace(/\.$/, '').trim();
      let items    = [];

      if (byLine.length > 1 && byLine.every(s => s.includes(':'))) {
        items = byLine.map(clean).filter(Boolean);
      }

      if (!items.length) {
        const byDot = flat.split(/\.\s+/).map(clean).filter(Boolean);
        if (byDot.length > 1) items = byDot;
      }

      if (!items.length && /\s*·\s*/.test(flat) && flat.includes('·')) {
        items = flat.split(/\s*·\s*/).map(clean).filter(Boolean);
      }

      if (!items.length && /\s[–\-]\s/.test(flat)) {
        items = flat.split(/\s[–\-]\s/).map(clean).filter(Boolean);
      }

      if (!items.length && (flat.match(/:/g) || []).length > 1) {
        const byKey = flat.split(/ (?=[A-ZÁÉÍÓÚÑ][A-ZÁÉÍÓÚÑa-záéíóúñ\d ]{1,30}:)/).map(clean).filter(Boolean);
        if (byKey.length > 1) items = byKey;
      }

      if (!items.length) return `<span>${escHtml(clean(flat))}</span>`;
      return '<ul class="comparator-composition-list">' +
        items.map(item => `<li>${escHtml(item)}</li>`).join('') +
        '</ul>';
    }

    _renderRating(product) {
      const avg   = parseFloat(product.fields && product.fields.rating_avg);
      const count = parseInt(product.fields && product.fields.rating_count, 10);

      if (!avg || isNaN(avg)) return '<span class="comparator-table__empty">—</span>';

      const uid   = 'cmp-' + product.id;
      const path  = 'M10 15.27L16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19z';
      const stars = Array.from({ length: 5 }, (_, i) => {
        const w = ((Math.min(1, Math.max(0, avg - i))) * 20).toFixed(2);
        const id = uid + '-s' + i;
        return `<svg class="comparator-rating__star" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">` +
          `<defs><clipPath id="${id}"><rect x="0" y="0" width="${w}" height="20"/></clipPath></defs>` +
          `<path class="comparator-rating__star-bg" d="${path}"/>` +
          `<path class="comparator-rating__star-fg" clip-path="url(#${id})" d="${path}"/>` +
          `</svg>`;
      }).join('');

      const countHtml = count ? `<span class="comparator-rating__count">${count} reseñas</span>` : '';

      return `<span class="comparator-rating" aria-label="${avg.toFixed(1)} de 5 estrellas">` +
        `<span class="comparator-rating__stars" aria-hidden="true">${stars}</span>` +
        `${countHtml}</span>`;
    }

    _renderPrice(product) {
      if (!product.price) return '<span class="comparator-table__empty">—</span>';
      const hasDiscount = product.compare_at_price && product.compare_at_price > product.price;
      if (hasDiscount) {
        return `<span class="comparator-price__wrap">` +
          `<span class="comparator-price comparator-price--sale">${formatPrice(product.price)}</span>` +
          `<s class="comparator-price comparator-price--compare">${formatPrice(product.compare_at_price)}</s>` +
          `</span>`;
      }
      return `<span class="comparator-price">${formatPrice(product.price)}</span>`;
    }

    _applyValuePadding() {
      if (this._mobilePairs) return; // handled per-pair in _applyMobileView
      this.modalContent.querySelectorAll('.comparator-table__th-product').forEach((el, i) => {
        el.style.paddingRight = i === 0 ? '20px' : '';
        el.style.paddingLeft  = i === 1 ? '20px' : '';
      });
      this.modalContent.querySelectorAll('.comparator-table__value').forEach((el, i) => {
        el.style.paddingLeft  = i % 2 === 1 ? '10px' : '';
        el.style.paddingRight = i % 2 === 0 ? '10px' : '';
      });
    }

    _initScrollFade() {
      this.modalContent.querySelectorAll('.cmp-sizes__scroll-wrap').forEach(wrap => {
        const scrollEl = wrap.querySelector('.variant-buttons');
        if (!scrollEl) return;

        const update = () => {
          const overflow = scrollEl.scrollWidth > scrollEl.clientWidth + 1;
          if (!overflow) { wrap.className = wrap.className.replace(/\bscroll-\S+/g, '').trim() + ' scroll-none'; return; }
          const atStart = scrollEl.scrollLeft <= 1;
          const atEnd   = scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 1;
          wrap.classList.remove('scroll-none', 'scroll-end', 'scroll-mid');
          if (atEnd && !atStart)   wrap.classList.add('scroll-end');
          else if (!atStart)       wrap.classList.add('scroll-mid');
        };

        scrollEl.addEventListener('scroll', update, { passive: true });
        requestAnimationFrame(() => requestAnimationFrame(update));

        // Mouse drag to scroll
        let isDragging = false;
        let startX = 0;
        let startScrollLeft = 0;

        scrollEl.addEventListener('mousedown', (e) => {
          isDragging = true;
          startX = e.pageX;
          startScrollLeft = scrollEl.scrollLeft;
          scrollEl.style.cursor = 'grabbing';
          scrollEl.style.userSelect = 'none';
          e.preventDefault();
        });

        const onMouseMove = (e) => {
          if (!isDragging) return;
          scrollEl.scrollLeft = startScrollLeft - (e.pageX - startX);
        };

        const onMouseUp = () => {
          if (!isDragging) return;
          isDragging = false;
          scrollEl.style.cursor = '';
          scrollEl.style.userSelect = '';
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });
    }

    _syncCardButtons() {
      const atMax = this.products.length >= this.config.max_products;
      document.querySelectorAll('[data-comparator-btn]').forEach(btn => {
        let id;
        try {
          id = JSON.parse(btn.dataset.product).id;
        } catch (_) {
          return;
        }
        const selected = this.isSelected(id);
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', String(selected));
        btn.disabled = atMax && !selected;
      });
    }

    _persist() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.products));
      } catch (_) {}
    }

    _restore() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (_) {
        return [];
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductComparator());
  } else {
    new ProductComparator();
  }

})();
